import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import { Link } from 'react-router-dom';


const ResourceRequest = () =>{
  
  return (
    <div className="ResourceRequest">
    
    <section className="inner-banner banner-align">
      <img className="img-fluid" src={process.env.PUBLIC_URL + "/assets/img/innerbanner/resource-request.jpg"} alt="Resource Request"/>
    </section>
    <section  className="research-box-area">
         <Container>
       
            <div className='information-content'>
              <h2>Resource Request</h2>
              {/* <p>Your University ID card is also your library card. You can borrow the library materials by presenting your card. our University ID card is also your library card. You can borrow the library materials by presenting your card.</p> */}
              <p>This is for the use of HU learning community only and requires a valid HU email ID. Before placing your suggestion, please check in the HU Library Catalog to see if the book is already in the library collection or on order.</p>
              <p>Please supply complete and correct information. The more complete the form is, the faster the request will be processed (including ISBN).</p>
              <p>Average delivery time from vendors varies from four weeks to two months.</p>
              <a href="https://habibuniversity.sharepoint.com/sites/Faculty/Pages/library-resource-request.aspx" className="btn-dfault" target="_blank">Resource Request</a>
              
            </div>

            <div className='information-content mt-5'>
              <h2>Inter Library Loan (ILL) Request</h2>
              <p>
                This service is available exclusively to the HU Learning Community and requires a valid HU email ID.
              </p>
              <p>
                Before submitting a request, please check the HU Library Catalog and E-Resources to make sure the book, article, or other resource is not already available through the Library.
              </p>
              <p>
                We will make every effort to obtain requested resources through our partner libraries, where available, and provide articles or book chapters electronically (PDF).
              </p>
              <p>
                Please provide complete and accurate information in the request form, including the ISBN, DOI, or other relevant details where applicable. The more complete your request, the faster it can be processed.
              </p>
              <p>
                <span><b>Average fulfillment time:</b></span> 48 hours.
              </p>
              <a href="https://habibuniversity.sharepoint.com/sites/intranet/Pages/Inter-Library-Loan.aspx?xsdata=MDV8MDJ8bWFzaGhvb2QuYW53YXJAaGFiaWIuZWR1LnBrfGQ0N2NlMzNiZWU1NjRjZmVkNjQxMDhkZjBhNWM0MDc3fDcwYzM1YWE0YmVkNDQ4ZjI5NWM5ZTNiYTJmN2MwMzdhfDB8MHw2MzkyNDEwNjM0OTkwMDA2ODZ8VW5rbm93bnxUV0ZwYkdac2IzZDhleUpGYlhCMGVVMWhjR2tpT25SeWRXVXNJbFlpT2lJd0xqQXVNREF3TUNJc0lsQWlPaUpYYVc0ek1pSXNJa0ZPSWpvaVRXRnBiQ0lzSWxkVUlqb3lmUT09fDB8fHw%3d&sdata=TXdJRHdjNyt5WnVKUGpodVRwekRwWFRaV0JmS2ZEQzNMOXdPeWVFVVJhdz0%3d"
               className="btn-dfault" target="_blank">Inter Library Loan Form</a>

            </div>
            
         </Container>
    </section>
   
  </div>
  );
}
export default ResourceRequest;